import React from "react";
import GenericModal from "../../../../../../components/modal/GenericModal";

const MensajeConfirmacionEliminarCasoModal = ({ idCaso, toggleModal, handleEliminarCaso }) => {
  return (
    <GenericModal showModal={toggleModal} width="500px" titulo={`Eliminar caso`}>
      <div className="modal-body pt-0 pl-0">
        <div className="container-fluid">
            <p>
                Se va a eliminar el caso seleccionado.
            </p>
            <p className="mb-0">
                ¿Está seguro de esta acción?
            </p>
        </div>
      </div>

      <div className="modal-footer d-flex justify-content-end">
        <div className="button">
          <button
            className="btn btn-primary generic-button-ficha mr-2"
            onClick={toggleModal}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary generic-button-ficha"
            onClick={async () => {
                toggleModal();
                await handleEliminarCaso(idCaso);
            }}
          >
            Aceptar
          </button>
        </div>
      </div>
    </GenericModal>
  );
};

export default MensajeConfirmacionEliminarCasoModal;
